import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/footer/footer-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/html-lang/html-lang.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/new-version/chunk-error-reload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/new-version/new-version-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/pagination/pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/results-table/empty-state.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/results-table/results.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/results-table/search-error-state.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search/src/components/top-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/app/apps/search/src/context/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchProvider"] */ "/app/apps/search/src/context/SearchContext.tsx");
